// components/WhatsappIcon.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsappIcon = () => {
const phoneNumber = '919315427607';
  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8 
                 bg-green-500 text-white rounded-full p-4 sm:p-5 md:p-6 z-50 shadow-xl 
                 hover:scale-125 hover:bg-green-600 transition-all duration-300 ease-in-out"
    >
      <FaWhatsapp className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9" />
    </a>
  );
};

export default WhatsappIcon;
